import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setCarTripSearchInputs } from '../../../../../store/slices/tripSearch';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import carSearchInput from '../../../../../helpers/selectors/carSearchInput';
import { carSearch } from '../../../../../store/slices/car';
import { transmissionTypes } from '../../../../../constants';

const TransmissionTypesFilter = ({ tripId, selectedTab, bgClassName }) => {
  const isTripSearch = !tripId;
  const { searchInputs } = useSelector(carSearchInput(tripId, selectedTab, isTripSearch));
  const { travelAgency } = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const filterLabel =
    (travelAgency &&
      travelAgency.filterSettings &&
      travelAgency.filterSettings.rentalCarTransmissionTypesFilterLabel) ||
    'Transmission';
  // const doShowRentalCarTransmissionFilter = (travelAgency && travelAgency.filterSettings
  //   && travelAgency.filterSettings.doShowRentalCarTransmissionFilter) || false;

  const handleChange = useCallback(
    (newValue) => {
      if (isTripSearch) {
        dispatch(
          setCarTripSearchInputs({
            transmissionTypes: newValue,
          }),
        );
      } else {
        dispatch(
          carSearch({
            tripId,
            selectedTab,
            searchObj: {
              ...searchInputs,
              page: 1,
              transmissionTypes: newValue,
            },
          }),
        );
      }
    },
    [dispatch, isTripSearch, searchInputs, selectedTab, tripId],
  );

  return (
    <>
      <CheckboxSelectFilter
        options={transmissionTypes}
        label={filterLabel}
        onChange={handleChange}
        values={searchInputs.transmissionTypes || []}
        variant={!isTripSearch ? 'outline' : undefined}
        bgClassName={!isTripSearch ? '' : bgClassName}
      />
    </>
  );
};

TransmissionTypesFilter.propTypes = {
  tripId: PropTypes.string,
  bgClassName: PropTypes.string,
  selectedTab: PropTypes.number,
};

TransmissionTypesFilter.defaultProps = {
  tripId: undefined,
  bgClassName: undefined,
  selectedTab: 0,
};

export default memo(TransmissionTypesFilter);
